import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import Pagination from '../components/Pagination';

const UserLogs = () => {
  const [logs, setLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const recordsPerPage = 10;

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/user-logs`, { withCredentials: true });
      setLogs(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const filteredLogs = logs.filter(log => 
    (log.user_name && log.user_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (log.action && log.action.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (log.ip_address && log.ip_address.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredLogs.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredLogs.slice(indexOfFirstRecord, indexOfLastRecord);

  return (
    <Layout title="System User Logs" subtitle="Audit trail of user logins and actions">
      <div className="bg-slate-900/20 border border-slate-900 rounded-3xl p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-bold text-white">Recent Activity</h3>
          <input 
            type="text" 
            placeholder="Search logs..." 
            className="bg-slate-950 border border-slate-800 p-2 rounded-xl text-white text-sm outline-none focus:border-emerald-500"
            value={searchTerm}
            onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }}
          />
        </div>
        
        <table className="w-full text-left border-collapse text-sm text-gray-300">
          <thead>
            <tr className="border-b border-slate-800 text-gray-500 font-mono">
              <th className="pb-3">S.No</th>
              <th className="pb-3">Timestamp</th>
              <th className="pb-3">Username</th>
              <th className="pb-3">Action</th>
              <th className="pb-3">IP Address</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800/50">
            {currentRecords.map((log, index) => (
              <tr key={log.id} className="hover:bg-slate-800/20">
                <td className="py-4 text-gray-500 font-mono text-xs">{indexOfFirstRecord + index + 1}</td>
                <td className="py-4 font-mono text-cyan-400">{new Date(log.log_time).toLocaleString()}</td>
                <td className="py-4 font-semibold text-white">{log.user_name}</td>
                <td className="py-4"><span className="px-2 py-1 rounded-md text-xs bg-indigo-500/10 text-indigo-400">{log.action}</span></td>
                <td className="py-4 font-mono text-gray-500">{log.ip_address}</td>
              </tr>
            ))}
            {currentRecords.length === 0 && (
              <tr>
                <td colSpan="5" className="py-8 text-center text-gray-500">No logs found. Try logging out and logging in.</td>
              </tr>
            )}
          </tbody>
        </table>
        <Pagination currentPage={currentPage} totalPages={totalPages} setCurrentPage={setCurrentPage} totalItems={filteredLogs.length} />
      </div>
    </Layout>
  );
};

export default UserLogs;
